import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { AssignmentRead } from 'src/common/external/bambi-api/bambiApi';

import { setShowAssignmentTransferModal } from '../../assignmentManagement.slice';
import { AssignmentTransferForm } from './AssignmentTransferForm';

interface AssignmentTransferModalProps {
  assignment: AssignmentRead;
}

export function AssignmentTransferModal({
  assignment,
}: AssignmentTransferModalProps) {
  const showAssignmentTransferModal = useAppSelector(
    (state) => state.assignmentManagement.showAssignmentTransferModal
  );

  if (!showAssignmentTransferModal) {
    return null;
  }

  return <AssignmentTransferModalContent assignment={assignment} />;
}

interface AssignmentTransferModalContentProps {
  assignment: AssignmentRead;
}

function AssignmentTransferModalContent({
  assignment,
}: AssignmentTransferModalContentProps) {
  const dispatch = useAppDispatch();
  const assignedTrips = useAppSelector(
    (state) => state.dispatcher.dispatchResponse?.assigned_trips
  );

  const onClose = () => {
    dispatch(setShowAssignmentTransferModal(false));
  };

  return (
    <AssignmentTransferForm
      assignment={assignment}
      assignedTrips={assignedTrips ?? []}
      onClose={onClose}
    />
  );
}
